import Experiments, { ExperimentsBag } from '@wix/wix-experiments';
import { join, keys, pickBy, pipe } from 'ramda';
import React, { createContext, FC, useContext, useMemo } from 'react';
import { ExperimentNames } from '../../constants/ExperimentNames';

const ExperimentsContext = createContext<{
  experiments: ExperimentsBag | undefined;
}>({
  experiments: undefined,
});

export const ExperimentsProvider: FC<{
  experiments: ExperimentsBag | undefined;
}> = ({ experiments, children }) => {
  return (
    <ExperimentsContext.Provider
      value={{
        experiments,
      }}
    >
      {children}
    </ExperimentsContext.Provider>
  );
};

export const useExperiments = () => {
  const { experiments } = useContext(ExperimentsContext);
  if (!experiments) {
    throw Error('Experiments are not provided');
  }

  const { isExperimentEnabled, getEnabledExperimentsNames } = useMemo(
    () => ({
      isExperimentEnabled: (experimentName: ExperimentNames) =>
        new Experiments({ experiments }).enabled(experimentName),
      getEnabledExperimentsNames: () =>
        pipe(
          pickBy((value) => value === 'true'),
          keys,
          join('|'),
        )(experiments),
    }),
    [experiments],
  );

  return { experiments, isExperimentEnabled, getEnabledExperimentsNames };
};
